import { Customizations } from 'models'

const futureAuctionVehiclesTableLabels: Customizations = {
  passingOrderNo: {
    label: 'Ord.',
    isDisplayed: true,
  },
  licensePlate: {
    label: 'Immat.',
    isDisplayed: true,
  },
  color: {
    label: 'Coul',
    isDisplayed: true,
  },
  type: {
    label: 'Ge',
    isDisplayed: true,
  },
  no: {
    label: 'Réf.',
    isDisplayed: true,
  },
  referenceVendeur: {
    label: 'Réf. vendeur',
    isDisplayed: true,
  },
  dateFirstReg: {
    label: 'MEC',
    isDisplayed: true,
  },
  version: {
    label: 'Type Commercial',
    isDisplayed: true,
  },
  mileage: {
    label: 'KM',
    isDisplayed: true,
  },
  coteArgusPriceDate: {
    label: 'CD',
    isDisplayed: true,
  },
  coteArgusKm: {
    label: 'CK',
    isDisplayed: true,
  },
  nbPassage: {
    label: 'NP',
    isDisplayed: true,
  },
  withdrawalPrice: {
    label: 'Prix retrait',
    isDisplayed: true,
  },
  reserveTTCHF: {
    label: 'Réserve',
    isDisplayed: true,
  },
  estimationApporteur: {
    label: 'Estimation',
    isDisplayed: true,
  },
  tvaRecuperable: {
    label: 'TVA',
    isDisplayed: true,
  },
  observationsVendeur: {
    label: 'Observat°',
    isDisplayed: true,
  },
}

export { futureAuctionVehiclesTableLabels }
